var shared = require('../../modules/shared');
var _vars = require('../../modules/vars')._vars;
var api = require('../../modules/providers/dify/api');
var template = require('../../ui/templates/drug-prompts.template');

var DOSING_KEYS = ['adult_dosing', 'pediatric_dosing', 'geriatric_dosing'];
var WRAPPER_MAP = {
    adult_dosing: 'ai-drug-prompts-adult-wrapper',
    pediatric_dosing: 'ai-drug-prompts-pediatric-wrapper',
    geriatric_dosing: 'ai-drug-prompts-geriatric-wrapper',
    adverse_events: 'ai-drug-prompts-adverse-wrapper'
};
var TRACKING_SECTION_MAP = {
    adult_dosing: 'dos-a',
    pediatric_dosing: 'dos-p',
    geriatric_dosing: 'dos-g',
    adverse_events: 'adv'
};

function isDrugPage() {
    return window.location.pathname.indexOf('/drug/') !== -1 && window.CURRENT_DRUG_ID != null && window.CURRENT_DRUG_ID !== '';
}

function getExistingWrappers() {
    var wrapperIds = Object.keys(WRAPPER_MAP).map(function(key) {
        return WRAPPER_MAP[key];
    });

    return wrapperIds.filter(function(wrapperId) {
        return !!document.getElementById(wrapperId);
    });
}

function clearWrapper(wrapperId) {
    var container = document.getElementById(wrapperId);
    if (!container) {
        return;
    }

    container.remove();
}

function normalizePromptList(list) {
    if (!Array.isArray(list)) {
        return [];
    }

    return list.filter(function(item) {
        return typeof item === 'string' && item.trim();
    }).map(function(item) {
        return item.trim();
    });
}

function openAiSearchModal() {
    if (document.body.classList.contains('show-ai-search-modal')) {
        return;
    }

    var fab = document.getElementById('ai-search-fab');
    if (fab) {
        fab.classList.remove('active');
    }
    document.body.classList.add('show-ai-search-modal');
}

function handlePromptClick(prompt, promptIndex, promptSection, event) {
    event.preventDefault();
    wmdTrack('ai-search_drg-smrt-q-' + promptSection + '-' + promptIndex);
    aiSchPageview(0);

    if (_vars.pending) {
        shared.handleStopGenerate();
    }

    _vars.suppressKeyPointsOnce = true;
    openAiSearchModal();
    shared.handleSearch(prompt);
}

function bindPromptEvents(container) {
    if (!container || container.getAttribute('data-drug-prompts-bound') === 'true') {
        return;
    }

    container.addEventListener('click', function(event) {
        var promptButton = event.target.closest('[data-prompt]');
        if (!promptButton || !container.contains(promptButton)) {
            return;
        }

        var prompt = promptButton.getAttribute('data-prompt');
        if (!prompt) {
            return;
        }

        var promptIndex = parseInt(promptButton.getAttribute('data-prompt-index'), 10) || 1;
        var promptSection = promptButton.getAttribute('data-prompt-section') || 'adv';
        handlePromptClick(prompt, promptIndex, promptSection, event);
    });

    container.setAttribute('data-drug-prompts-bound', 'true');
}

function renderPromptsForWrapper(wrapperId, prompts, trackingSection) {
    var container = document.getElementById(wrapperId);
    if (!container) {
        return;
    }

    var normalizedPrompts = normalizePromptList(prompts);
    if (!normalizedPrompts.length) {
        clearWrapper(wrapperId);
        return;
    }

    // mlink index must restart at 1 per section, not continue across sections
    container.innerHTML = template.drugPromptsTemplate(normalizedPrompts, 1, trackingSection);
    bindPromptEvents(container);
}

function renderDosingPrompts(dosingData) {
    var dosing = dosingData || {};

    DOSING_KEYS.forEach(function(subKey) {
        var wrapperId = WRAPPER_MAP[subKey];
        var prompts = normalizePromptList(dosing[subKey]);
        renderPromptsForWrapper(wrapperId, prompts, TRACKING_SECTION_MAP[subKey]);
    });
}

function renderAdversePrompts(adverseData) {
    var adverse = adverseData || {};
    var prompts = normalizePromptList(adverse.prompts);
    renderPromptsForWrapper(WRAPPER_MAP.adverse_events, prompts, TRACKING_SECTION_MAP.adverse_events);
}

function fetchAndRender() {
    return api.getArticlePrompts().then(function(res) {
        return res.json();
    }).then(function(data) {
        var prompts = data && data.prompts ? data.prompts : {};
        renderDosingPrompts(prompts.dosing_and_uses);
        renderAdversePrompts(prompts.adverse_events);
    }).catch(function() {
        Object.keys(WRAPPER_MAP).forEach(function(key) {
            clearWrapper(WRAPPER_MAP[key]);
        });
    });
}

function initDrugPrompts() {
    if (!isDrugPage()) {
        return;
    }

    var existingWrappers = getExistingWrappers();
    if (!existingWrappers.length) {
        return;
    }

    if (_vars.token) {
        fetchAndRender();
        return;
    }

    api.generateToken().then(function(data) {
        if (data && data.token) {
            _vars.token = 'Bearer ' + data.token;
        }
    }).then(fetchAndRender).catch(function() {
        existingWrappers.forEach(clearWrapper);
    });
}

module.exports = {
    initDrugPrompts: initDrugPrompts
};
